import React from 'react';
import { Button, Drawer } from "@mui/material";
import LandingCommunityLogsUpdateIssued from "./LandingCommunityLogsUpdateIssued";
import LandingCommunityLogsUpdateRedeemed from "./LandingCommunityLogsUpdateRedeemed";

export default function LandingCommunityLogsUpdate({ open, setOpen, row, mode, setLoadingVouchers }) {

    const [mode1, setMode1] = React.useState('issued');

    return (
        <Drawer anchor={"right"} open={open} onClose={() => setOpen(false)}>
            <div style={{ padding: 20, width: 400 }}>

                <div style={{ display: 'flex' }}>
                    <Button 
                        disabled={mode1 === 'issued'} 
                        onClick={() => setMode1('issued')} 
                    >
                        {mode === 'issued' ? 'Contact' : 'Owner'}
                    </Button>
                    <Button 
                        disabled={mode1 === 'redeemed'} 
                        onClick={() => setMode1('redeemed')} 
                    >
                        Animal
                    </Button>
                </div>

                {mode1 === 'issued' && <LandingCommunityLogsUpdateIssued row={row} mode={mode} setOpen={setOpen} setLoadingVouchers={setLoadingVouchers} />}
                {mode1 === 'redeemed' && <LandingCommunityLogsUpdateRedeemed row={row} mode={mode} setOpen={setOpen} setLoadingVouchers={setLoadingVouchers} />}

            </div>
        </Drawer>
    );
}
